import * as SoundAssets from '../assets/sounds';
import { SoundId, SoundIds } from '../types/sounds';

export const SoundMap: Partial<Record<SoundId, { src: string }>> = Object.freeze({
  [SoundIds.KL_MUSIC]: { src: SoundAssets.KLGenerique },
  [SoundIds.KL_FLUTES_1]: { src: SoundAssets.KLFlute1 },
  [SoundIds.KL_FLUTES_2]: { src: SoundAssets.KLFlute2 },
  [SoundIds.KL_FLUTES_3]: { src: SoundAssets.KLFlute3 },
  [SoundIds.KL_FLUTES_4]: { src: SoundAssets.KLFlute4 },
  [SoundIds.KL_FLUTES_5]: { src: SoundAssets.KLFlute5 },
  [SoundIds.KL_FLUTES_6]: { src: SoundAssets.KLFlute6 },
  [SoundIds.KL_INTRO]: { src: SoundAssets.KLIntro },
  [SoundIds.KL_BADGE_WON_FISHING]: { src: SoundAssets.KLBadgeWonFishing },
  [SoundIds.KL_BADGE_LOST_FISHING]: { src: SoundAssets.KLBadgeLostFishing },
  [SoundIds.KL_BADGE_WON_FIRECAMP]: { src: SoundAssets.KLBadgeWonFirecamp },
  [SoundIds.KL_BADGE_LOST_FIRECAMP]: { src: SoundAssets.KLBadgeLostFirecamp },
  [SoundIds.KL_BADGE_WON_HUT]: { src: SoundAssets.KLBadgeWonHut },
  [SoundIds.KL_BADGE_LOST_HUT]: { src: SoundAssets.KLBadgeLostHut },
  [SoundIds.KL_BADGE_WON_RICE]: { src: SoundAssets.KLBadgeWonRice },
  [SoundIds.KL_BADGE_LOST_RICE]: { src: SoundAssets.KLBadgeLostRice },
  [SoundIds.KL_BADGE_WON_WATER]: { src: SoundAssets.KLBadgeWonWater },
  [SoundIds.KL_BADGE_LOST_WATER]: { src: SoundAssets.KLBadgeLostWater },
  [SoundIds.KL_BADGE_WON_BALANCE]: { src: SoundAssets.KLBadgeWonBalance },
  [SoundIds.KL_BADGE_LOST_BALANCE]: { src: SoundAssets.KLBadgeLostBalance },
  [SoundIds.KL_BADGE_WON_GRAND_BLUE]: { src: SoundAssets.KLBadgeWonGrandBlue },
  [SoundIds.KL_BADGE_LOST_GRAND_BLUE]: { src: SoundAssets.KLBadgeLostGrandBlue },
  [SoundIds.KL_BADGE_WON_DUO]: { src: SoundAssets.KLBadgeWonDuo },
  [SoundIds.KL_BADGE_LOST_DUO]: { src: SoundAssets.KLBadgeLostDuo },
  [SoundIds.KL_BADGE_WON_SLOTH]: { src: SoundAssets.KLBadgeWonSloth },
  [SoundIds.KL_BADGE_LOST_SLOTH]: { src: SoundAssets.KLBadgeLostSloth },
  [SoundIds.KL_BADGE_WON_BAMBOOS]: { src: SoundAssets.KLBadgeWonBamboos },
  [SoundIds.KL_BADGE_LOST_BAMBOOS]: { src: SoundAssets.KLBadgeLostBamboos },
  [SoundIds.KL_COMFORT_WON]: { src: SoundAssets.KLComfortWon },
  [SoundIds.KL_COMFORT_LOST]: { src: SoundAssets.KLComfortLost },
  [SoundIds.KL_COLLAR_WON]: { src: SoundAssets.KLCollarWon },
  [SoundIds.KL_COLLAR_LOST]: { src: SoundAssets.KLCollarLost },
  [SoundIds.KL_COLLAR_USED]: { src: SoundAssets.KLCollarUsed },
  [SoundIds.KL_ELIMINATION_T_RED]: { src: SoundAssets.KLEliminationTRed },
  [SoundIds.KL_ELIMINATION_T_WHITE]: { src: SoundAssets.KLEliminationTWhite },
  [SoundIds.KL_TRANSITION_T_WHITE]: { src: SoundAssets.KLTransitionTWhite },
  [SoundIds.KL_TRANSITION_ORIENTATION]: { src: SoundAssets.KLTransitionOrientation },
  [SoundIds.KL_TRANSITION_POLE]: { src: SoundAssets.KLTransitionPole },
  [SoundIds.KL_MARK_WON]: { src: SoundAssets.KLMarkWon },
  [SoundIds.KL_MARK_LOST]: { src: SoundAssets.KLTagLost },
  [SoundIds.KL_TAG_WON]: { src: SoundAssets.KLTagWon },
  [SoundIds.KL_TAG_LOST]: { src: SoundAssets.KLTagLost },
  [SoundIds.KL_KNIFE_WON]: { src: SoundAssets.KLKnifeWon },
  [SoundIds.KL_KNIFE_LOST]: { src: SoundAssets.KLTagLost },
  [SoundIds.KL_KNIFE_MISS_1]: { src: SoundAssets.KLKnifeLost1 },
  [SoundIds.KL_KNIFE_MISS_2]: { src: SoundAssets.KLKnifeLost2 },
  [SoundIds.KL_KNIFE_MISS_3]: { src: SoundAssets.KLKnifeLost3 },
  [SoundIds.KL_POLE_WON]: { src: SoundAssets.KLPoleWon },
  [SoundIds.KL_POLE_WON_STAGE_1]: { src: SoundAssets.KLPoleWonStage1 },
  [SoundIds.KL_POLE_WON_STAGE_2]: { src: SoundAssets.KLPoleWonStage2 },
  [SoundIds.KL_POLE_WON_STAGE_3]: { src: SoundAssets.KLPoleWonStage3 },
  [SoundIds.KL_POLE_WON_STAGE_4]: { src: SoundAssets.KLPoleWonStage4 },
  [SoundIds.KL_POLE_WON_STAGE_5]: { src: SoundAssets.KLPoleWonStage5 },
  [SoundIds.KL_POLE_LOST]: { src: SoundAssets.KLPoleLost },
  [SoundIds.KL_POLE_FALL_STAGE_1]: { src: SoundAssets.KLPoleFallStage1 },
  [SoundIds.KL_POLE_FALL_STAGE_2]: { src: SoundAssets.KLPoleFallStage2 },
  [SoundIds.KL_POLE_FALL_STAGE_5]: { src: SoundAssets.KLPoleFallStage5 },
  [SoundIds.KL_POLE_PRICE_WON]: { src: SoundAssets.KLPolePriceWon },
  [SoundIds.KL_TRY_AGAIN]: { src: SoundAssets.KLTryAgain },
  [SoundIds.KL_VICTORY_1]: { src: SoundAssets.KLVictory1 },
  [SoundIds.KL_VICTORY_2]: { src: SoundAssets.KLVictory2 },
  [SoundIds.KL_VICTORY_3]: { src: SoundAssets.KLVictory3 },
  [SoundIds.KL_VICTORY_4]: { src: SoundAssets.KLVictory4 },
  [SoundIds.KL_VICTORY_5]: { src: SoundAssets.KLVictory5 },
  [SoundIds.KL_VICTORY_6]: { src: SoundAssets.KLVictory6 },
  [SoundIds.KL_VICTORY_7]: { src: SoundAssets.KLVictory7 },
  [SoundIds.KL_VICTORY_8]: { src: SoundAssets.KLVictory8 },
  [SoundIds.KL_VICTORY_9]: { src: SoundAssets.KLVictory9 },
  [SoundIds.KL_VICTORY_10]: { src: SoundAssets.KLVictory10 },
  [SoundIds.KL_VICTORY_11]: { src: SoundAssets.KLVictory11 },

  [SoundIds.KL_VOTE_1]: { src: SoundAssets.KLVote1 },
  [SoundIds.KL_VOTE_2]: { src: SoundAssets.KLVote2 },
  [SoundIds.KL_VOTE_3]: { src: SoundAssets.KLVote3 },
  [SoundIds.KL_RESTART]: { src: SoundAssets.KLRestart },
  [SoundIds.ANTHEM_DE]: { src: SoundAssets.AnthemDE },
  [SoundIds.ANTHEM_ES]: { src: SoundAssets.AnthemES },
  [SoundIds.ANTHEM_FR]: { src: SoundAssets.AnthemFR },
  [SoundIds.GR_WIN_BLUE_TAG_MOVING]: { src: SoundAssets.GRWinBlueTagMovingSound },
  [SoundIds.GR_WIN_MULTIPLICATOR_WHEEL]: { src: SoundAssets.GRWinMultiplicatorWheelSound },
  [SoundIds.GR_WIN_TOTAL_FREEBETS_AMOUNT_INCREMENT]: { src: SoundAssets.GRWinTotalFreebetsAmountIncrementSound },
  [SoundIds.GR_WIN_TICK]: { src: SoundAssets.GRWinTickSound },
  [SoundIds.GR_WIN_CHIP]: { src: SoundAssets.GRWinChipSound },
  [SoundIds.GR_LOST_CHIP]: { src: SoundAssets.GRLostChipSound },
  [SoundIds.MP_WIN_CARD]: { src: SoundAssets.MPCardSound },
  [SoundIds.MP_WIN_FAMILY]: { src: SoundAssets.MPFamilySound },

  [SoundIds.GLOBAL_FREEBETS]: { src: SoundAssets.FreebetsSound },

  [SoundIds.BOOM_HALLOWEEN_BASKET]: { src: SoundAssets.WitchLaughSound },
  [SoundIds.BOOM_START]: { src: SoundAssets.BoomStartSound },
});
